import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './confirmDeleteClosingDayDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { ClosingDay } from '@/types/ClosingDays'
import { DELETE_CLOSING_DAY } from '@/modules/API/daycare/closingDayHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmDeleteClosingProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    closingDay: ClosingDay
    refetchAllEvents: () => Promise<void>
}

const ConfirmDeleteClosingDayDialog: FunctionComponent<ConfirmDeleteClosingProps> = ({
    open,
    handleClose,
    daycareId,
    closingDay,
    refetchAllEvents
}: ConfirmDeleteClosingProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneEventDay] = useMutation(DELETE_CLOSING_DAY, {
        variables: {
            daycare_id: daycareId,
            closing_day_id: Number(closingDay.id)
        },
        onCompleted: () => {
            refetchAllEvents()

            showNotificationSuccess(t('closingDayDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('closingDayNotDeleted'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('deleteClosingDay')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('deleteClosingDayMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteOneEventDay}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteClosingDayDialog
